import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalBody,
    Input,
    Row,
    Col,
    Label,
    FormGroup,
    FormFeedback,
} from "reactstrap";

const defaultTeamForm = {
    id: "",
    name: "",
    status: "active",
    isBackend: false,
};

const TeamAddEditModal = ({
    teamAddEditModalOpen,
    setTeamAddEditModalOpen,
    editableData = null, // pass existing item to edit
    onSubmit, // function(finalData) => void
}) => {
    const [teamForm, setTeamForm] = useState({ ...defaultTeamForm });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (!teamAddEditModalOpen) return;
        if (editableData?.id || editableData?._id) {
            setTeamForm({
                id: editableData?.id || editableData?._id || "",
                name: editableData?.name || "",
                status:
                    String(editableData?.status || "").toLowerCase() === "active"
                        ? "active"
                        : "deactive",
                isBackend: Boolean(editableData?.isBackend ?? editableData?.isbackend ?? false),
            });
        } else {
            setTeamForm({ ...defaultTeamForm });
        }
        setErrors({});
    }, [editableData, teamAddEditModalOpen]);

    const closeModal = () => {
        setTeamAddEditModalOpen(false);
    };

    const handleTeamFormChange = (field, value) => {
        setTeamForm((prev) => ({ ...prev, [field]: value }));
        setErrors((prev) => {
            if (!prev[field]) return prev;
            const copy = { ...prev };
            delete copy[field];
            return copy;
        });
    };

    const validateForm = () => {
        const newErrors = {};

        if (!String(teamForm?.name || "").trim()) {
            newErrors.name = "Name is required.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (!validateForm()) return;
        const finalData = { ...teamForm };

        if (typeof onSubmit === "function") {
            onSubmit(finalData);
        }
    };

    return (
        <Modal
            isOpen={teamAddEditModalOpen}
            toggle={closeModal}
            backdrop="static"
            size="md"
            className="modal-full-height"
            centered
        >
            <ModalBody className="modal-height-fixed overflow-y-auto">
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="fw-bold m-0">
                        {teamForm?.id ? "EDIT" : "CREATE"}
                    </h5>
                    <Button close onClick={closeModal} />
                </div>
                <hr />

                <Row className="mt-3">
                    <Col md={12}>
                        <FormGroup>
                            <Label className="fw-semibold">Name *</Label>
                            <Input
                                type="text"
                                value={teamForm?.name || ""}
                                invalid={!!errors.name}
                                onChange={(e) => handleTeamFormChange("name", e.target.value)}
                            />
                            <FormFeedback>{errors.name}</FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Col md={12}>
                        <Label className="fw-semibold m-0">Status *</Label>
                        <div className="input-box d-flex align-items-center justify-content-between mt-2">
                            <span className="text-muted">Type</span>
                            <div className="d-flex align-items-center">
                                <strong className="me-2">
                                    {String(teamForm?.status) === "active" ? "Active" : "Deactive"}
                                </strong>
                                <div className="form-switch">
                                    <Input
                                        type="switch"
                                        name="status"
                                        className="form-check-input-padding"
                                        key={`team-status-${teamForm?.id || "new"}-${String(teamForm?.status)}`}
                                        defaultChecked={String(teamForm?.status) === "active"}
                                        onChange={(e) =>
                                            handleTeamFormChange("status", e?.target?.checked ? "active" : "deactive")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col md={12}>
                        <div className="d-flex align-items-center">
                            <Label className="fw-semibold m-0">Is Backend? *</Label>
                            <Input
                                key={`isBackend-${teamForm?.id || "new"}-${teamForm?.isBackend ? "1" : "0"}`}
                                type="checkbox"
                                defaultChecked={!!teamForm?.isBackend}
                                onChange={(e) => handleTeamFormChange("isBackend", !!e?.target?.checked)}
                                className="ms-2"
                            />
                        </div>
                    </Col>
                </Row>

                <div className="text-end mt-4">
                    <Button color="success" onClick={handleSubmit}>
                        <i className="bx bx-save me-1"></i>
                        Save
                    </Button>
                </div>
            </ModalBody>

        </Modal>
    );
};

export default TeamAddEditModal;
